import {Routes} from '@angular/router';

export const redpacketManagementRoutes: Routes = [
  {
    path: 'redpacketManagement',
    data: { title: '红包管理' },
    children: [
      {
        path: '',
        loadComponent: () => import('./redpacket-management.component').then(m => m.RedpacketManagementComponent),
        data: { title: '红包列表' },
      },
      {
        path: 'receiveList/:redpacketId',
        loadComponent: () => import('./redpacket-receive-list/redpacket-receive-list.component').then(m => m.RedpacketReceiveListComponent),
        data: { title: '红包领取记录' },
      }
    ]
  },
];
